"use client"

import dynamic from "next/dynamic"
import { useInView } from "react-intersection-observer"
import { BentoGridSkeleton } from "./_component/bento-skeleton"

const DynamicBentoGrid = dynamic(
  () => import("./bento-grid").then((mod) => mod.default),
  {
    loading: () => <BentoGridSkeleton />,
  }
)

export default function BentoGridWrapper() {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  })

  return <div ref={ref}>{inView && <DynamicBentoGrid />}</div>
}
